import { differenceInMinutes } from "date-fns";
import { cn } from "@/lib/utils";
import { MapPin } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface AssetLocationCardProps {
  locationName: string;
  startTime: Date;
  endTime: Date;
  weekStart: Date;
  totalMinutes: number;
}

export function AssetLocationCard({
  locationName,
  startTime,
  endTime,
  weekStart,
  totalMinutes,
}: AssetLocationCardProps) {
  // Calculate position and width as percentages
  const startMinutes = differenceInMinutes(startTime, weekStart);
  const durationMinutes = differenceInMinutes(endTime, startTime);

  const leftPercent = Math.max(0, (startMinutes / totalMinutes) * 100);
  const widthPercent = Math.min((durationMinutes / totalMinutes) * 100, 100 - leftPercent);

  // Don't render if too small
  if (widthPercent < 0.5) return null;

  return (
    <TooltipProvider>
      <Tooltip delayDuration={200}>
        <TooltipTrigger asChild>
          <div
            className={cn(
              "absolute top-[50%] -translate-y-1/2 h-[24px] rounded border bg-muted/60"
            )}
            style={{
              left: `${leftPercent}%`,
              width: `${Math.max(widthPercent, 0.3)}%`,
              minWidth: "4px",
            }}
          />
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <div className="text-xs">
            <span className="font-medium">At location:</span> {locationName}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
